module.exports = __webpack_public_path__ + "img/4.cebd6422.jpg";